<template>
  <div class="select">
    <div class="con-right">
      <div
        v-if="data.fieldtype === 'radioinfo_type' && infoSignOptions.length"
        class="top"
        :class="{ hide: !infoSign || $route.query.tab == 'addFollowup' }"
      >
        <cube-checkbox
          :value="isBeian === 1"
          shape="square"
          :option="{ disabled: !infoSign.isedit && ($route.name === 'InqueryPassDetail' || $route.name === 'InqueryDetail') }"
          @input="onChangeBeian"
        >
          {{ infoSignOptions[0].name }}
        </cube-checkbox>
        <span
          v-if="!$isEnglish"
          class="text"
        >
          销售自己开发获得的信息
        </span>
      </div>
      <cube-select
        v-if="data.isedit || $route.name === 'InqueryCreate'"
        v-model="defaultVal"
        :options="options"
        :title="data.fieldname"
        :placeholder="placeholder"
        class="select"
        @change="handleChange"
      />
      <not-can-edit-item
        v-else
        :data="data"
      />
    </div>
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import NotCanEditItem from './NotCanEdit'

export default {
  components: {
    NotCanEditItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    let defaultVal = this.value || this.data.fieldvalue
    return {
      defaultVal,
      isBeian: 0
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'passdetailMemberInfo']),
    ...mapGetters('inquery/addConfigData', ['defaultMemberInfo']),
    isInfoSign: {
      get () {
        let data = {}
        if (this.$route.name === 'InqueryCreate') {
          data = this.defaultMemberInfo
        } else {
          data = this.passdetailMemberInfo
        }
        const { isInfoSign } = data || {}
        return isInfoSign
      },
      set (val) {
        this.SET_IS_INFO_SIGN(val)
      }
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    systemRole () {
      const { system_role: systemRole } = this.baseinfo || {}
      return systemRole
    },
    options () {
      const { options = [], fieldtype = '', parentid } = this.data

      let isRadio = fieldtype === 'radio' || fieldtype === 'radioinfo_type'
      let isSelect = fieldtype === 'select'
      // 父级不是成交，丢单，失效
      let isChildModule = parentid === 5092 || parentid === 136528 || parentid === 136525
      // 信息类型和父级不是成交，丢单，失效，模块内的单选和下拉
      if ((isRadio || isSelect) && !isChildModule) {
        // 录入或审核
        if (this.$route.name === 'InqueryCreate' || this.auditStatus === 0 || this.auditStatus === -1) {
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 2) {
              options.splice(i, 1)
            }
          }
        } else if (this.auditStatus === 1) { // 通过审核的详情
          for (let len = options.length, i = len - 1; i >= 0; i--) {
            if (options[i].visibletype === 1) {
              options.splice(i, 1)
            }
          }
        }
      }
      return options.map(item => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
    placeholder () {
      const { placeholder = '' } = this.data
      return placeholder
    },
    infoSign () {
      const { fieldconfig = {} } = this.data || {}
      const { info_sign: infoSign = {} } = fieldconfig
      return infoSign
    },
    infoSignOptions () {
      let { options = [] } = this.infoSign
      return options
    }
  },

  watch: {
    value (val) {
      this.defaultVal = this.value
      this.setInvisibleValue()
    },
    data: {
      handler (val) {
        if (this.value) {
          this.defaultVal = this.value
        } else {
          this.defaultVal = val.fieldvalue === 0 ? '' : val.fieldvalue
        }
        this.setInvisibleValue()
      },
      deep: true,
      immediate: true
    },
    systemRole: {
      handler (val) {
        const { fieldtype } = this.data || {}
        if (!val || fieldtype !== 'radioinfo_type') return

        if (this.$route.name === 'InqueryCreate' && this.baseinfo.system_role === 5) {
          // 销售,录入页面，操作信息类型字段时，默认选中备案
          if (this.isInfoSign) {
            if (this.infoSign) {
              // 默认选中信息类型标记备案
              this.isBeian = 1
            }
            let item = this.options.find(o => o.text === this.$t('message[1762]'))
            this.defaultVal = item.value
          } else {
            // 默认选中信息类型的备案字段
            let { options = [] } = this.data || {}
            let item = options.find(o => o.name === this.$t('message[26]')) // 备案
            this.defaultVal = item && item.id
            this.isBeian = 1
          }

          // 处理共享和store内备案的值
          this.setBeiAn(this.isBeian === 1)
          this.$bus.$emit('handleChangeBeian', this.isBeian === 1)

          this.data.fieldvalue = this.defaultVal
          this.$emit('change', this.defaultVal)
        } else {
          this.setDefaultBeian()
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations('inquery/detailData', ['updataIsBeiAn']),
    ...mapMutations('inquery/relateData', ['SET_IS_INFO_SIGN']),
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    setDefaultBeian () {
      /* const { fieldvalue } = this.infoSign
      this.isBeian = fieldvalue
      this.setBeiAn(this.isBeian === 1) */
      if (this.isInfoSign) { // 如果设置了允许备案为true
        const { fieldvalue } = this.infoSign || {}
        this.isBeian = fieldvalue
        this.setBeiAn(this.isBeian === 1)
      } else { // 如果信息类型选择了备案
        let { options = [] } = this.data || {}
        let item = options.find(o => o.name === this.$t('message[26]')) // 备案
        let { id } = item || {}
        const { fieldvalue } = this.data || {}
        if (id === fieldvalue) {
          this.setBeiAn(true)
        }
      }
    },
    setInvisibleValue () {
      if (!this.defaultVal) return

      let isfind = this.options.find(item => item.value === this.defaultVal)
      if (this.defaultVal && !isfind) {
        this.defaultVal = undefined
        if (this.data.isneeded) {
          this.$emit('change', this.defaultVal)
        }
      }
    },
    handleChange (value, index, text) {
      let { fieldkey, options = [] } = this.data || {}
      this.data.fieldvalue = value

      // 旧项目，不可以配置备案标记，isInfoSign返回的0
      if (fieldkey === 'info_type' && !this.isInfoSign) {
        const InfoTypeitem = options.find(o => o.name === this.$t('message[26]')) // 备案
        let { id } = InfoTypeitem || {}
        // 切换选择的是备案
        this.setBeiAn(id === value)
        // 接口获取跟进人员默认值
        this.$bus.$emit('handleChangeBeian', this.fieldvalue)
      }

      this.$emit('change', value)
    },

    onChangeBeian (checked) {
      let val = checked
      // 传递给接口的isBeian值为0或1
      this.isBeian = val ? 1 : 0
      this.data.fieldconfig.info_sign.fieldvalue = this.isBeian
      // 标记为备案，信息类型默认选中有效，之前选择过的值覆盖为有效
      // 取消备案时不处理，保留之前选择的
      // 通过的详情，选择备案，不强制选择有效
      if (val && !(this.$route.name === 'InqueryDetail' && this.auditStatus === 1)) {
        let item = this.options.find(o => o.text === this.$t('message[1762]'))
        this.defaultVal = item.value
        this.$forceUpdate()
      }
      this.setBeiAn(val)
      this.$emit('change', this.defaultVal)
      this.$bus.$emit('handleChangeBeian', val)
    },
    setBeiAn (val) {
      // 更新共享选项
      this.$bus.$emit('updateFollowShare', val)
      // 是否选择备案，在store中存储isBeian的状态，Boolean
      this.updataIsBeiAn(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.con-right {
  .top {
    display: flex;
    &.hide {
      display: none;
    }
    .cube-checkbox {
      padding: 0;
    }
    .text {
      margin-left: 8px;
      font-size: 12px;
      color: #999;
    }
  }
}
.select ::v-deep {
  flex: 1;
  .cube-select {
    > .cube-select-text {
      display: flex;
      // width: calc(100%-20px);
      width: 240px;
      word-break: break-all;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .cube-select-icon {
    border-color: #d6d6d6 transparent transparent;
  }
  .cube-select-placeholder {
    color: #d6d6d6;
  }
}
</style>
